module.exports = __webpack_public_path__ + "img/29ne.ff9534f8.svg";